import { FC } from 'react';
import Icon from 'components/icons/Icon';

const Pinning: FC<{ onClick: () => void; className?: string }> = ({ onClick, className = '' }) => (
    <div>
        <Icon icon="pin" className={`${className}`} onClick={onClick} />
    </div>
);
export default Pinning;
